export default __webpack_public_path__ + "static/media/PalmasOpen.f7bb7fa2.jpg";